const header = {
  mobileHeight: '60px',
  tabletHeight: '70px'
}

export default header
